import { COLOR_BROWN } from "modules/storyblok/templates/AirHelpScore/styles";
import { Flex, Image, Text } from "@chakra-ui/react";
import { useLocalizedData } from "contexts/LocalizationContext/hooks";
import type { ScoreTagProps } from "./ScoreTag.d";
import { STORYBLOK_ASSET_MANAGER_URL } from "../../utils";

const iconsIds = ["941ea7a5cf", "2d3cb39170", "b21d39122e"];

const scoreNumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const ScoreTag = ({ index, score, size = "sm" }: ScoreTagProps) => {
  const { getLocalizedNumber } = useLocalizedData();
  let scoreTagColor = "warning.500";
  const localizedScore = getLocalizedNumber(score, scoreNumberFormatOptions);

  if (index === 1) {
    scoreTagColor = "greyscale.500";
  } else if (index === 2) {
    scoreTagColor = COLOR_BROWN;
  }

  const tagProps =
    size === "sm"
      ? {
          py: 1,
          px: 2,
        }
      : {
          size: "lg",
          px: 3,
          h: "42px",
          maxW: 36,
          margin: "0 auto",
        };

  const image =
    size === "sm" ? null : (
      <Image
        src={`${STORYBLOK_ASSET_MANAGER_URL}/f/108829/24x24/${iconsIds[index]}/icons_trophy_${index + 1}.svg`}
        mr={2.5}
      />
    );

  const label =
    size === "sm" ? (
      <Text fontWeight="medium" fontSize="sm">
        {localizedScore}/10
      </Text>
    ) : (
      <Text fontWeight="medium" fontSize="lg">
        {localizedScore} / 10
      </Text>
    );

  return (
    <Flex align="center" bg={scoreTagColor} borderRadius="sm" color="white" {...tagProps}>
      {image}
      {label}
    </Flex>
  );
};

export default ScoreTag;
